import React from 'react';
import { DebtService } from 'components';

export const DebtServicePage = () => {
    return <DebtService />;
};
